/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import icono_localizacion from '../../../../Recursos/Ic_location.svg'
import icono_llamada from '../../../../Recursos/icono_llamada_contacto.svg'
import icono_correo from '../../../../Recursos/icono_correo_contacto.svg'
import icono_nit from '../../../../Recursos/icono_nit_black_contacto.svg'
import Tarjeta_Contacto_Home from "../Tarjetas/Tarjeta_Contacto_Home";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {CONTACTOS} from "../../../../Constantes";


const Lista_Contactos_Home = () => {
    const {sCell, sTab} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}

            size={12}>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sCell ? 0 : `2px solid #000`, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={CONTACTOS[0].img}
                    contacto={CONTACTOS[0].descripcion}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sCell ? 0 : `2px solid #000`, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={CONTACTOS[1].img}
                    contacto={CONTACTOS[1].descripcion}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sCell ? 0 : `2px solid #000`, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={CONTACTOS[2].img}
                    contacto={CONTACTOS[2].descripcion}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sTab ? `2px solid #000` : 0, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={CONTACTOS[3].img}
                    contacto={CONTACTOS[3].descripcion}/>
            </Grid2>

        </Grid2>
    )

}
export default Lista_Contactos_Home;